import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/aboutConference/background',
      component: () => import('@/views/aboutConference/AboutBackground.vue'),
      meta: { title: '大会背景' },
      name: 'AboutBackground',
    },
    {
      path: '/aboutConference/charter',
      component: () => import('@/views/aboutConference/AboutCharter.vue'),
      meta: { title: '大会章程' }
    },
    {
      path: '/aboutConference/committee',
      component: () => import('@/views/aboutConference/AboutCommittee.vue'),
      meta: { title: '组委会' }
    },
    {
      path: '/aboutConference/experts',
      component: () => import('@/views/aboutConference/AboutExperts.vue'),
      meta: { title: '智库专家' }
    },
    {
      path: '/aboutConference/contact',
      name: 'Contact',
      component: () => import('@/views/aboutConference/Contact.vue'),
      meta: { title: '联系我们' }
    },
    {
      path: '/aboutConference/committee/type/:typeId',
      name: 'CommitteeTypeDetail',
      component: () => import('@/views/aboutConference/CommitteeTypeDetail.vue'),
      meta: {
        title: '组委会详情',
        activeMenu: '/aboutConference/committee'
      }
    },
    {
      path: '/contact',
      component: () => import('@/views/aboutConference/Contact.vue'),
      meta: { title: '联系我们' }
    },
    {
      path: '/news/announcements',
      component: () => import('@/views/news/NewsAnnouncements.vue'),
      meta: { title: '通知公告' },
      name: 'NewsAnnouncements'
    },
    {
      path: '/news/info',
      component: () => import('@/views/news/NewsInfo.vue'),
      meta: { title: '大会资讯' }
    },
    {
      path: '/news/future',
      component: () => import('@/views/news/NewsFuture.vue'),
      meta: { title: '职教未来' }
    },
    {
      path: '/news/detail/:id',
      name: 'NewsDetail',
      component: () => import('@/views/news/NewsDetails.vue'),
      props: true,
      meta: {
        title: '新闻详情'

      }
    },
    {
      path: '/column/detail/:id',
      name: 'ColumnDetail',
      component: () => import('@/views/news/ColumnDetail.vue'),
      props: true,
      meta: {
        title: '专栏详情',
        activeMenu: '/news/info'
      }
    },
    {
      path: '/column/newsDetail/:id',
      name: 'ColumnNesDetail',
      component: () => import('@/views/news/ColumnNewsDetails.vue'),
      props: true,
      meta: {
        title: '专栏新闻详情',
        activeMenu: '/news/info'
      }
    },
    {
      path: '/column',
      name: 'Columns',
      component: () => import('@/views/news/Columns.vue'),
      props: true,
      meta: {
        title: '专栏',
        activeMenu: '/news/info'
      }
    },
    {
      path: '/events/pastEvents',
      component: () => import('@/views/events/EventsPast.vue'),
      meta: { title: '历届活动' },
      name: 'EventsPast'
    },
    {
      name: 'EventsCurrent',
      path: '/events/currentEvents/:id',
      component: () => import('@/views/events/EventsCurrent.vue'),
      meta: { title: '大会活动' },
      props: true
    },
    {
      path: '/events/otherEvents',
      component: () => import('@/views/events/EventsOther.vue'),
      meta: { title: '其他活动' }
    },
    {
      path: '/members/aboutMembers',
      component: () => import('@/views/member/MembersAbout.vue'),
      meta: { title: '关于会员' },
      name: 'MembersAbout'
    },
    {
      path: '/members/joinMembers',
      component: () => import('@/views/member/MembersJoin.vue'),
      meta: { title: '申请入会' }
    },
    {
      path: '/members/introCommitee',
      component: () => import('@/views/member/introCommitee.vue'),
      meta: { title: '组委会简介' }
    },
    {
      path: '/partners/intro',
      component: () => import('@/views/partner/PartnersIntro.vue'),
      meta: { title: '合作伙伴介绍' }
    },
    {
      path: '/partners/thanks',
      component: () => import('@/views/partner/PartnersThanks.vue'),
      meta: { title: '合作伙伴鸣谢' }
    },
    {
      path: '/partners/news',
      component: () => import('@/views/partner/PartnersNews.vue'),
      meta: { title: '合作伙伴动态' }
    },
    {
      path: '/partners/apply',
      component: () => import('@/views/partner/PartnersApply.vue'),
      meta: { title: '合作伙伴申请' }
    },
    {
      path: '/result/distinguishedEducators',
      component: () => import('@/views/result/distinguishedEducators.vue'),
      meta: { title: '杰出教育工作者' }
    },
    {
      path: '/result/notableContributions',
      component: () => import('@/views/result/notableContributions.vue'),
      meta: { title: '突出贡献' }
    },
    {
      path: '/result/influenceIndex',
      component: () => import('@/views/result/influenceIndex.vue'),
      meta: { title: '亚太影响力指数' },
      name: 'InfluenceIndex'
    },
    {
      path: '/result/exemplaryInstitutions',
      component: () => import('@/views/result/exemplaryInstitutions.vue'),
      meta: { title: '典型院校' }
    },
    {
      path: '/result/exemplaryProject',
      component: () => import('@/views/result/exemplaryProject.vue'),
      meta: { title: '示范项目' }
    },
    {
      path: '/project/details/:id',
      component: () => import('@/views/result/ProjectDetails.vue'),
      props: true,
      meta: {
        title: '示范项目内容',
        activeMenu: '/result/exemplaryProject'
      }
    },
    {
      path: '/result/outstandingCases',
      component: () => import('@/views/result/outstandingCases.vue'),
      meta: {
        title: '优秀案例'

      }
    },
    {
      path: '/outstandingCases/detail/:id',
      component: () => import('@/views/result/CaseDetails.vue'),
      props: true,
      meta: {
        title: '案例详情',
        activeMenu: '/result/outstandingCases'
      }
    },
    {
      path: '/user/profile',
      component: () => import('@/views/user/UserProfile.vue'),
      meta: { title: '我的账号' }
    },
    {
      path: '/user/myEvents',
      component: () => import('@/views/user/UserEvents.vue'),
      meta: { title: '我的报名' }
    },
    {
      path: '/user/registrations',
      component: () => import('@/views/user/UserRegistrations.vue'),
      meta: { title: '注册' }
    },
    {
      path: '/user/security',
      component: () => import('@/views/user/UserSecurity.vue'),
      meta: { title: '安全设置' }
    },
    {
      path: '/user/login',
      component: () => import('@/views/user/UserLogin.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/user/register',
      component: () => import('@/views/user/UserRegistrations.vue'),
      meta: { title: '注册', activeMenu: '/user/login' }
    },
    {
      path: '/vocEdMap',
      component: () => import('@/views/vocEdMap.vue'),
      meta: { title: '职教图谱' }
    },

    {
      path: '/careerCompetition',
      component: () => import('@/views/competition/careerCompetition.vue'),
      meta: { title: '职业大赛' }
    },
    {
      path: '/competition/detail/:id',
      name: 'competitionDetails',
      component: () => import('@/views/competition/competitionDetails.vue'),
      props: true,
      meta: {
        title: '大赛详情',
        activeMenu: '/careerCompetition' // 强制指定激活菜单
      }
    },
    {
      path: '/competition/subList/:id',
      name: 'competitionSubList',
      component: () => import('@/views/competition/competitionSubList.vue'),
      props: true,
      meta: {
        title: '赛项列表',
        activeMenu: '/careerCompetition'
      }
    },
    {
      path: '/competition/sub/detail/:id',
      name: 'competitionSubDetail',
      component: () => import('@/views/competition/competitionSubDetail.vue'),
      props: true,
      meta: {
        title: '赛项详情',
        activeMenu: '/careerCompetition'
      }
    },
    {
      path: '/case/detail/:id',
      name: 'caseDetails',
      component: () => import('@/views/events/CaseDetail.vue'),
      props: true,
      meta: {
        title: '案例征集',
        activeMenu: '/events/currentEvents/0'
      },
    },
    {
      path: '/meetingRace/detail/:id',
      name: 'meetingRaceDetails',
      component: () => import('@/views/events/MeetingRaceDetail.vue'),
      props: true,
      meta: {
        title: '会议大赛',
        activeMenu: '/events/currentEvents/0'
      },
    },
    {
      path: '/forum/detail/:id',
      component: () => import('@/views/events/ForumDetail.vue'),
      meta: {
        title: '论坛详情',
        activeMenu: '/events/currentEvents/0'
      },
      props: true
    },
    {
      path: '/events/registration',
      component: () => import('@/views/events/EventsRegistration.vue'),
      meta: {
        title: '报名',
        activeMenu: '/events/currentEvents/0'
      },
      props: true
    },
    { path: '/registration/form', component: () => import('@/views/events/RegistrationForm.vue'), meta: { title: '表单', activeMenu: '/events/currentEvents/0' }, props: true },
     { path: '/events/sign-in/:conventionId', component: () => import('@/views/events/SignInPage.vue'), meta: { title: '会议签到', activeMenu: '/events/currentEvents/0', hiddenHeader: true, hiddenFooter: true }, props: true },
    {
      path: '/forum/detail/',
      component: () => import('@/views/events/ForumDetail.vue'),
      meta: { title: '论坛详情', activeMenu: '/events/currentEvents/0' }
    },
    {
      path: '*',
      component: () => import('@/views/Home.vue'),
      meta: { title: '首页' }
    },

  ],
  scrollBehavior(to, from, savedPosition) {

    if (to.hash) {
      return {
        selector: to.hash,
        // 添加默认值处理
        behavior: (to.meta.smoothScroll !== false) ? 'smooth' : 'auto',
        offset: { x: 0, y: 100 } // 增加偏移量避免被固定头遮挡
      }
    }

    if (savedPosition) {
      return savedPosition || { x: 0, y: 0 }
    }

    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          x: 0,
          y: 0,
          // 添加浏览器兼容性判断
          behavior: window.__forceSmoothScroll ? 'smooth' : 'auto'
        })

      }, 150)
    })
  },
});

// router.js
router.beforeEach((to, from, next) => {
  if (to.path === from.path &&
    JSON.stringify(to.params) === JSON.stringify(from.params)) {
    // return next(false)
  }
  if (window._hmt && to.path) {
    window._hmt.push(['_trackPageview', to.fullPath]);
  }
  next()
})
export default router